// extracted by mini-css-extract-plugin
export default {"wrapper":"g4iFgidFcfxN29aNfF3x","primaryTeal":"uBm3JzKm25FJ85rWZnBd"};